import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getSubscriptionPlan,
  cancelSubscriptionPlan
} from "../../../modules/subscription/action";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import TransactionHistory from "./TransactionHistory";
import { Button } from "@material-ui/core";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import Loader from "../../Loader";

class BillingView extends Component {
  state = {
    planId: userDetail().planId,
    subscriptionLists: [],
    endDate: userDetail().endDate,
    open: false
  };
  componentWillMount() {
    this.props.actions.getSubscriptionPlan();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.subscriptionList &&
      this.props.subscriptionList !== nextProps.subscriptionList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ subscriptionLists: nextProps.subscriptionList });
    }
  }
  subscriptionLists;

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleCancelSub = () => {
    this.setState({
      open: true
    });
  };

  handleOk = () => {
    this.props.actions.cancelSubscriptionPlan(userDetail().username);
    this.setState({ open: false });
  };

  render() {
    const { subscriptionList = [], isplanCancelled, isLoading } = this.props;
    const { planId, endDate, open } = this.state;
    const prevPath = "settings",
      currentPage = "/billing";
    console.log("Rerender");
    return !isLoading ? (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
          message="Do you really want to unsubscribe"
        />
        <TabHeaderAndButton
          header="My Plan"
          path={`/${prevPath}${currentPage}/changePlan`}
          isDisabled={
            userDetail().planId === 4 ||
            (isSuperAdmin() &&
              this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id)
          }
          btnLabel="Upgrade Subscription"
          isVisible={userDetail().stripeUser || userDetail().planId === 1}
        />
        <div className="flex-display ticket-header">
          <h3 style={{ margin: "1em 0em 0em 1em" }}>
            {subscriptionList &&
              subscriptionList
                .filter(data => {
                  return data.id === planId;
                })
                .map(data => {
                  return `${data.name}`;
                })}
          </h3>
        </div>
        <div style={{ margin: "1em 0em 0em 1em" }}>
          {subscriptionList &&
            subscriptionList
              .filter(data => {
                return data.id === planId;
              })
              .map(data => {
                return `This plan allows you to have ${
                  data.noOfContracts === -1 ? "Unlimited" : data.noOfContracts
                }  contracts + ${
                  data.noOfTickets === -1 ? "Unlimited" : data.noOfTickets
                } Tickets`;
              })}
        </div>

        <div style={{ margin: "0em 1em" }}>
          {subscriptionList &&
            subscriptionList
              .filter(data => {
                return data.id === planId;
              })
              .map(data => {
                const msg =
                  userDetail().paymentStatus &&
                  userDetail().paymentStatus.includes("suspended")
                    ? "Your plan will be expired on"
                    : "Your plan will renew on";
                return `${msg} ${endDate} for ${data.currency}${data.fees}`;
              })}
        </div>
        <div style={{ margin: "0em 1em" }}>
          {subscriptionList &&
            subscriptionList
              .filter(data => {
                return data.id === planId;
              })
              .map(data => {
                return `Number of users allowed: ${data.noOfLogins}`;
              })}
        </div>
        <br />
        <br />
        <hr />
        <TransactionHistory />
        <div className="flex-display ticket-header">
          <div></div>
          {userDetail().stripeUser &&
            !isplanCancelled &&
            userDetail().paymentStatus == "paid" &&
            userDetail().planId !== 1 && (
              <Button
                className="cancel-sub-button"
                onClick={this.handleCancelSub}
              >
                Cancel subscription
              </Button>
            )}
        </div>
      </div>
    ) : (
      <Loader />
    );
  }
}

function mapStateToProps(state) {
  return {
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    subscriptionList: state.subscriptionList.subscriptionListDetails,
    isplanCancelled: state.subscriptionList.isplanCancelled,
    isLoading: state.subscriptionList.isLoading
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getSubscriptionPlan,
        cancelSubscriptionPlan
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingView);



// WEBPACK FOOTER //
// ./src/components/private/Billing/BillingView.js